import React from "react";
import { IDivider } from "../../interfaces/Components/Divider/IDivider";

import './Divider.scss';

export const Divider: React.FC<IDivider> = ({ ...props }) => {

    const className = `divider ${props.className || ''}`;
    return (
        <div className={className}></div>
    );
    
}
